import React from 'react';
import { View } from 'react-native';
import BookingPlatformsRow from '../../cards/shared/BookingPlatformsRow';

export interface BookingTabProps {
  supabaseClient?: any;
  extractCardId: () => string | null;
  uploadCardType: 'lodging' | 'restaurant' | 'poi';
  basePayloadRef: React.MutableRefObject<any>;
  localBasePayload: any;
  normalizedCard?: any;
}

const BookingTab: React.FC<BookingTabProps> = ({ supabaseClient, extractCardId, uploadCardType, basePayloadRef, localBasePayload, normalizedCard }) => {
  return (
    <View style={{ paddingVertical: 4 }}>
      <BookingPlatformsRow
        mode={'view'}
        supabaseClient={supabaseClient}
        cardId={extractCardId() || undefined}
        displayVariant={(uploadCardType === 'lodging' ? 'lodging' : 'restaurant') as any}
        platformProductId={
          basePayloadRef.current?.platform_product_id ||
          localBasePayload?.platform_product_id ||
          normalizedCard?.platform_product_id ||
          normalizedCard?.base_payload?.platform_product_id
        }
        platformProductIds={
          basePayloadRef.current?.platform_product_ids ||
          localBasePayload?.platform_product_ids ||
          normalizedCard?.platform_product_ids ||
          normalizedCard?.base_payload?.platform_product_ids
        }
        hideLabel={true}
      />
    </View>
  );
};

export default BookingTab;
